import React from 'react';
import { LaunchOutlinedIcon } from 'tuui';
import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import { ENTITY_TO_PATH_MAP } from 'modules/campaigns/config/routes/entity';
import { AddConversion } from 'modules/campaigns/modules/common-campaign-form/components/AddConversionButton/AddConversionButton';
import { AddTrackingButton } from 'modules/campaigns/modules/common-campaign-form/components/AddTrackingButton/AddTrackingButton';
import { MARKETING_OBJECTIVE_KEYS } from 'modules/campaigns/modules/common-campaign-form/config';
import { validationFunctions } from '../../../../taboola-common-frontend-modules/validations';

export const marketingObjectiveValidations = [
    {
        validationFn: validationFunctions.isNotEmpty,
        messageId: 'validations.error.campaign.marketing.objective.empty',
        defaultMessage: 'Select a Marketing Objective',
    },
    {
        validationFn: (value, options, { isPixelOrS2sInstalled, isPixelWarningPermitted, isPixelWarningsTesting }) => {
            if (!isPixelWarningPermitted || !isPixelWarningsTesting) {
                return true;
            }
            if (
                value === MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION ||
                value === MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES ||
                value === MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL
            ) {
                return isPixelOrS2sInstalled;
            }
            return true;
        },
        messageId: 'campaign.marketing.objective.validations.noPixelImplementation',
        messageValues: {
            tracking: <AddTrackingButton />,
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (value, options, { isPixelOrS2sInstalled, isPixelWarningPermitted, isPixelWarningsTesting }) => {
            if (!isPixelWarningPermitted || !isPixelWarningsTesting) {
                return true;
            }

            if (
                value === MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS ||
                value === MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC
            ) {
                return isPixelOrS2sInstalled;
            }
            return true;
        },
        messageId: 'campaign.marketing.objective.validations.worksBestWithPixel',
        messageValues: {
            tracking: <AddTrackingButton />,
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (
            value,
            options,
            { hasAtLeastOneActiveConversion, isPixelWarningPermitted, isPixelWarningsTesting }
        ) => {
            if (!isPixelWarningPermitted || !isPixelWarningsTesting) {
                return true;
            }
            if (
                value === MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION ||
                value === MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES ||
                value === MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL
            ) {
                return hasAtLeastOneActiveConversion;
            }
            return true;
        },
        messageId: 'campaign.marketing.objective.validations.noActivity',
        messageValues: {
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (
            value,
            options,
            { hasAtLeastOneActiveConversion, isPixelWarningPermitted, isPixelWarningsTesting }
        ) => {
            if (!isPixelWarningPermitted || !isPixelWarningsTesting) {
                return true;
            }
            if (
                value === MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS ||
                value === MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC
            ) {
                return hasAtLeastOneActiveConversion;
            }
            return true;
        },
        messageId: 'campaign.marketing.objective.validations.worksBestWithActiveConversion',
        messageValues: {
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },

    {
        validationFn: (value, options, { entityType, savedMarketingObjective, hasCampaigns }) => {
            if (!value || entityType !== ENTITY_TO_PATH_MAP.CAMPAIGNS_GROUP) {
                return true;
            }

            if (hasCampaigns) {
                return value === savedMarketingObjective;
            }
            return true;
        },
        messageId: 'campaign.marketing.objective.validations.campaignGroup',
        defaultMessage: 'Changing the group objective won’t update existing campaigns. Make sure they still match.',
        severity: INDICATION_TYPES.WARNING,
    },

    {
        validationFn: (
            value,
            options,
            { entityType, isMandatoryHierarchyEnabled, campaignGroupMarketingObjective }
        ) => {
            if (
                !isMandatoryHierarchyEnabled ||
                !value ||
                entityType !== ENTITY_TO_PATH_MAP.CAMPAIGN ||
                campaignGroupMarketingObjective === MARKETING_OBJECTIVE_KEYS.NONE
            ) {
                return true;
            }
            if (campaignGroupMarketingObjective) {
                return value === campaignGroupMarketingObjective;
            }

            return true;
        },
        messageId: 'campaign.marketing.objective.validations.campaign',
        defaultMessage:
            "Campaign objective differs from group's. For best results, use a group with a matching objective.",
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (
            value,
            options,
            { entityType, isMandatoryHierarchyEnabled, campaignGroupMarketingObjective }
        ) => {
            if (
                isMandatoryHierarchyEnabled &&
                entityType === ENTITY_TO_PATH_MAP.CAMPAIGN &&
                campaignGroupMarketingObjective === MARKETING_OBJECTIVE_KEYS.NONE &&
                value === MARKETING_OBJECTIVE_KEYS.NONE
            ) {
                return false;
            }
            return true;
        },
        messageId: 'validations.error.campaign.marketing.objective.empty',
        events: ['submitOnly'],
    },
];
